// Carolina K accessibility fixes (vanilla JS). Log every change in a11y-carolinak.md.
(function () {

  /* ---------- Helpers ---------- */

  // Run after the DOM is parsed
  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      setTimeout(fn);
    }
  }

  function each(selector, fn) {
    document.querySelectorAll(selector).forEach(fn);
  }

  function setAttr(selector, name, value) {
    each(selector, function (el) { el.setAttribute(name, value); });
  }

  function removeAttr(selector, name) {
    each(selector, function (el) { el.removeAttribute(name); });
  }

  function siblings(el, selector) {
    if (!el.parentNode) return [];
    return Array.prototype.filter.call(el.parentNode.children, function (sibling) {
      return sibling !== el && sibling.matches(selector);
    });
  }

  function eventTarget(event) {
    var target = event.target;
    return target && target.nodeType === 3 ? target.parentNode : target;
  }

  // Click event for links that runs only this file's handlers (no navigation)
  var A11Y_CLICK = 'a11y:click';

  // Delegated document listener; click handlers also get A11Y_CLICK
  function on(type, selector, handler) {
    var types = type === 'click' ? ['click', A11Y_CLICK] : [type];
    types.forEach(function (t) {
      document.addEventListener(t, function (event) {
        if (!selector) {
          handler.call(document, event);
          return;
        }
        var target = eventTarget(event);
        var matched = target && target.closest ? target.closest(selector) : null;
        if (matched) handler.call(matched, event);
      });
    });
  }

  function triggerClick(el) {
    if (el.nodeName.toLowerCase() === 'a') {
      el.dispatchEvent(new CustomEvent(A11Y_CLICK, { bubbles: true, cancelable: true }));
    } else {
      el.click();
    }
  }

  /* ---------- Carousels, drawers, quick view, modals ---------- */

  onReady(function () {
    setTimeout(function () {
      setAttr('.flickity-page-dots', 'aria-hidden', 'true');
    }, 1000);
    setTimeout(function () {
      removeAttr('.is-selected', 'aria-hidden');
      removeAttr('.product-index', 'role');
    }, 1000);

    setAttr('.theme-features__image-flip--enabled .reveal .hidden', 'aria-hidden', 'true');

    setTimeout(function () {
      removeAttr('.slideshow', 'tabindex');
      setAttr('.shogun-accordion-title', 'role', 'button');
      setAttr('.shogun-icon-plus', 'aria-hidden', 'true');
      removeAttr('.featured__collection-carousel.flickity__section', 'tabindex');
      // A11Y-066: same for product carousels added later (e.g. product recommendations)
      new MutationObserver(function () {
        removeAttr('.featured__collection-carousel.flickity__section[tabindex]', 'tabindex');
      }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['tabindex'] });
    }, 1000);
    setAttr('br', 'aria-hidden', 'true');
    setAttr('hr', 'aria-hidden', 'true');
    removeAttr('#search-drawer', 'aria-expanded');
    removeAttr('.slideout--active', 'aria-expanded');
    removeAttr('#slideout-search-sidebar', 'aria-expanded');
    setTimeout(function () {
      setAttr('#slideout-search-sidebar', 'aria-modal', 'true');
      setAttr('#slideout-search-sidebar', 'role', 'dialog');
      setAttr('#slideout-search-sidebar', 'aria-hidden', 'true');
      setAttr('.mobile-menu', 'aria-hidden', 'true');
    }, 1000);
    setAttr('.js-quickview-trigger .icon--icon-theme-search.vib-center', 'aria-label', 'Quick View');

    var lastTriggeredButton;

    // Track the last clicked button
    on('click', '.js-modal-open.js-quickview-trigger', function () {
      lastTriggeredButton = this;
    });

    // Handle close button click
    on('click', '.js-modal-close', function () {
      if (lastTriggeredButton) {
        lastTriggeredButton.focus(); // Redirect focus back
      }
    });

    var lastClickedButton;

    // Track button click
    on('click', '.product-listing__quickview-trigger', function () {
      lastClickedButton = this;
    });

    // Close Function
    function close(openerEl) {
      const activeOpenModals = document.querySelectorAll('.modal--active');
      const openers = document.querySelectorAll('.js-modal-open');

      // Remove content if quickview
      if (openerEl && openerEl.getAttribute('aria-controls') === 'modal-quickview') {
        document.querySelector('.js-quickview-content').innerHTML = '';
      }

      // Close the Modal
      const wrapper = document.querySelector('.js-modal-toggle-wrapper');
      wrapper.classList.remove('modal--open');
      wrapper.classList.add('modal--closed');

      // Close all active modals
      activeOpenModals.forEach(function (activeModalDrawer) {
        if (activeModalDrawer.getAttribute('data-wau-modal')) {
          let elClass = activeModalDrawer.getAttribute('data-wau-modal');
          elClass = 'modal-' + elClass + '--open';
          wrapper.classList.remove(elClass);
        }
        activeModalDrawer.classList.remove('modal--active');
      });

      // Reset aria-expanded
      openers.forEach(function (opener) {
        opener.setAttribute('aria-expanded', 'false');
      });

      // Reset inline styles and body scroll lock
      ['overflow', 'position', 'padding-right', 'top', 'width'].forEach(function (style) {
        wrapper.style.removeProperty(style);
      });
      document.body.classList.remove('overflow-hidden');
    }

    // Handle Escape key press
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        const activeModalOpener = document.querySelector('.js-modal-open[aria-expanded="true"]');
        if (activeModalOpener) {
          close(activeModalOpener);

          // Return focus to the last clicked button
          if (lastClickedButton) {
            setTimeout(function () { lastClickedButton.focus(); }, 500);
          }
        }
      }
    });
  });

  /* ---------- External link, phone and email labels ---------- */

  // A11Y-041: one wording for links that leave the site
  var EXTERNAL_WARNING = ' (Redirecting to a third-party website, opens in a new tab)';

  function labelLinks(selector, prefix, maxLength, cutLength) {
    each(selector, function (link) {
      var originalTitle = link.textContent;
      var trimmedTitle = originalTitle.length > maxLength ? originalTitle.substring(0, cutLength) + '' : originalTitle;
      link.setAttribute('aria-label', prefix + trimmedTitle + EXTERNAL_WARNING);
      link.setAttribute('target', '_blank');
      link.removeAttribute('title');
    });
  }

  // A11Y-042: every email/phone link reads "Email Address: <link text>" / "Phone Number: <link text>"
  function labelContactLinks(selector, prefix, scheme) {
    each(selector, function (link) {
      var text = link.textContent.replace(/\s+/g, ' ').trim();
      if (!text) text = decodeURIComponent(link.getAttribute('href').replace(scheme, '').split('?')[0]);
      link.setAttribute('aria-label', prefix + text);
    });
  }

  // external warnings
  onReady(function () {
    labelLinks('a[href="https://us.fsc.org/en-us/%20certification)"],a[href="https://carolinak.loopreturns.com/#/"],a[href="https://www.google.com/maps/dir/25.8394142,-80.1986642/Carolina+K+Flagship+Design+District,+Northeast+2nd+Avenue,+Miami,+FL/@25.8278314,-80.2053722,15z/data=!3m1!4b1!4m9!4m8!1m1!4e1!1m5!1m1!1s0x88d9b1de0f9b438b:0xde3b830c17167894!2m2!1d-80.1916023!2d25.8157537?entry=ttu&g_ep=EgoyMDI0MTAwOC4wIKXMDSoASAFQAw%3D%3D"],a[href="https://www.google.com/maps/place/Carolina+K/@25.8157537,-80.26782,13z/data=!4m10!1m2!2m1!1scarolina+k+store!3m6!1s0x88d9b1de0f9b438b:0xde3b830c17167894!8m2!3d25.8157537!4d-80.1916023!15sChBjYXJvbGluYSBrIHN0b3JlkgEOY2xvdGhpbmdfc3RvcmXgAQA!16s%2Fg%2F11y352crrt?entry=ttu"],a[href="https://www.googhttps://www.google.com/maps/place/7924+NE+2nd+Ave,+Miami,+FL+33138/@25.8484022,-80.1957976,17z/data=!3m1!4b1!4m5!3m4!1s0x88d9b178d16543cb:0xebddde8945437b92!8m2!3d25.8484022!4d-80.1936089"],a[href="https://www.google.com/maps?daddr=33140+COLLINS+AVENUE+MIAMI+FL+33140"]', '', 20, 100);
  });

  // A11Y-047: "Directions" links name their location, e.g. "Directions to Miami Flagship Store"
  function headingBefore(link) {
    var el = link.parentElement;
    while (el && el !== document.body) {
      var headings = el.querySelectorAll('h1, h2, h3, h4, h5, h6');
      for (var i = headings.length - 1; i >= 0; i--) {
        if (headings[i].compareDocumentPosition(link) & Node.DOCUMENT_POSITION_FOLLOWING) {
          return headings[i].textContent.replace(/\s+/g, ' ').trim();
        }
      }
      el = el.parentElement;
    }
    return '';
  }

  function labelDirectionsLinks() {
    each('a[href]', function (link) {
      var text = link.textContent.replace(/\s+/g, ' ').trim();
      if (!/^(get )?directions$/i.test(text)) return;
      var place = headingBefore(link);
      if (!place) return;
      var label = text.charAt(0).toUpperCase() + text.slice(1).toLowerCase() + ' to ' + place;
      if (link.hostname && link.hostname !== window.location.hostname && link.target === '_blank') label += EXTERNAL_WARNING;
      link.setAttribute('aria-label', label);
    });
  }
  onReady(labelDirectionsLinks); // runs after the external-links block above

  // phone and email labels
  onReady(function () {
    labelContactLinks('a[href^="tel:" i]', 'Phone Number: ', /^tel:/i);
    labelContactLinks('a[href^="mailto:" i]', 'Email Address: ', /^mailto:/i);
  });

  /* ---------- Header menus and dropdowns ---------- */

  function closeMenuOnEscape(event) {
    if (event.key === 'Escape') {
      const dropdown = this; // The dropdown element

      // Remove 'menu-item' class
      dropdown.classList.remove('menu-item');

      // Update aria-expanded to false on the associated button (sibling)
      const buttons = siblings(dropdown, '.js-menu-link');
      buttons.forEach(function (button) {
        button.setAttribute('aria-expanded', 'false');
      });

      // A11Y-024: return focus to the button so it is not left on a hidden link
      if (buttons[0] && dropdown.contains(document.activeElement)) buttons[0].focus();
    }
  }

  on('keydown', '.megamenu.nestedmm', closeMenuOnEscape);
  on('keydown', '.dropdown.js-dropdown', closeMenuOnEscape);

  on('click', '.product-listing__quickview-trigger', function () {
    window.lastFocusedElement = this; // Store clicked button
    const checkModal = setInterval(function () {
      const modals = document.querySelectorAll('.modal__container.modal--active');
      if (modals.length) {
        modals.forEach(function (modal) { modal.setAttribute('tabindex', '-1'); });
        modals.forEach(function (modal) { modal.focus(); }); // Focus modal
        clearInterval(checkModal); // Stop checking
      }
    }, 100);
  });

  on('click', '.button-as-link.slideout__trigger-search.js-slideout-open', function () {
    // Wait for the drawer to become active, then focus on it
    setTimeout(function () {
      const drawer = document.getElementById('slideout-search-sidebar');
      if (drawer) {
        drawer.setAttribute('tabindex', '-1'); // Ensure the drawer is focusable and set focus
        drawer.focus();
      }
    }, 100); // Delay to ensure drawer is fully opened
  });

  // Toggle header dropdowns (must stay above the outside-click listeners)
  on('click', '.assistance-drop, .sale-drop, .mega-drop', function (event) {
    event.preventDefault(); // Prevent default action for links (if any)

    const button = this; // The button that was clicked
    const next = button.nextElementSibling;
    const dropdown = next && next.matches('.js-dropdown, .megamenu.nestedmm') ? next : null; // The associated dropdown (next sibling)

    // Close all other dropdowns
    each('.assistance-drop, .sale-drop, .mega-drop', function (el) {
      if (el !== button) el.setAttribute('aria-expanded', 'false');
    });
    each('.js-dropdown, .megamenu.nestedmm', function (el) {
      if (el !== dropdown) el.classList.remove('menu-item');
    });

    // Toggle the clicked dropdown
    const isExpanded = button.getAttribute('aria-expanded') === 'true';
    button.setAttribute('aria-expanded', String(!isExpanded));

    if (dropdown) {
      if (!isExpanded) {
        dropdown.classList.add('menu-item');
      } else {
        dropdown.classList.remove('menu-item');
      }
    }
  });

  on('click', null, function (e) {
    // Check if click happened outside the megamenu or menu link
    if (!eventTarget(e).closest('.megamenu.nestedmm.menu-item, .js-menu-link')) {
      // Remove 'menu-item' class
      each('.megamenu.nestedmm', function (el) { el.classList.remove('menu-item'); });

      // Set aria-expanded to false
      setAttr('.js-menu-link', 'aria-expanded', 'false');
    }
  });

  on('click', null, function (e) {
    // Check if click happened outside the megamenu, dropdown, or menu links
    if (!eventTarget(e).closest('.megamenu.nestedmm.menu-item, .dropdown.js-dropdown.menu-item, .js-menu-link')) {
      // Remove 'menu-item' class from both menus
      each('.megamenu.nestedmm, .dropdown.js-dropdown', function (el) { el.classList.remove('menu-item'); });

      // Set aria-expanded to false on menu links
      setAttr('.js-menu-link', 'aria-expanded', 'false');
    }
  });

  /* ---------- Search drawer ---------- */

  on('click', '.slideout__trigger-search-sidebar.js-slideout-close', function () {
    const searchButton = document.getElementById('search-drawer');

    // Focus on the button with ID "search-drawer"
    if (searchButton) {
      searchButton.focus();

      // Set aria-expanded to false
      searchButton.setAttribute('aria-expanded', 'false');
    }
  });

  document.addEventListener('keydown', function (event) {
    const searchDrawer = document.getElementById('slideout-search-sidebar');

    // Check if the Escape key is pressed and the drawer is active
    if (event.key === 'Escape' && searchDrawer && searchDrawer.classList.contains('slideout--active')) {
      setTimeout(function () {
        // Focus on the button with ID "search-drawer"
        const searchButton = document.getElementById('search-drawer');
        if (searchButton) {
          searchButton.focus();
          // Set aria-expanded to false
          searchButton.setAttribute('aria-expanded', 'false');
        }
      }, 1000); // 1-second delay before focusing
    }
  });

  /* ---------- Sold-out swatches ---------- */

  setTimeout(function () {
    each('.swatches__swatch--regular.swatch-element.soldout input', function (input) {
      var inputValue = input.value.trim(); // Trim the input value
      input.setAttribute('aria-label', inputValue + ' - Sold Out'); // Set aria-label with trimmed value and "Sold Out"
    });
  }, 1000); // Delay in milliseconds (e.g., 1000ms = 1 second)

  /* ---------- Close dropdowns when focus leaves them ---------- */

  function closeMenuOnFocusOut() {
    const dropdown = this; // The element losing focus
    const buttons = siblings(dropdown, '.js-menu-link'); // The associated button (sibling)

    // Wait until focus has really left the dropdown
    setTimeout(function () {
      if (!dropdown.querySelector(':focus') && !dropdown.matches(':focus')) {
        // Remove 'menu-item' class and update aria-expanded
        dropdown.classList.remove('menu-item');
        buttons.forEach(function (button) { button.setAttribute('aria-expanded', 'false'); });
      }
    }, 400);
  }

  on('focusout', '.megamenu.nestedmm.menu-item', closeMenuOnFocusOut);
  on('focusout', '.dropdown.js-dropdown.menu-item', closeMenuOnFocusOut);

  /* ---------- Form field labels ---------- */

  setAttr('input[data-type="email"]', 'aria-label', 'Enter Email');
  setAttr('textarea[data-type="textarea"]', 'aria-label', 'Enter Message');

  /* ---------- Shogun press "Read More" button labels ---------- */

  // A11Y-002: label from the article headings, e.g. "Read More: <title> - <publication>"
  each('a.shg-btn', function (link) {
    if (link.textContent.trim().toLowerCase() !== 'read more') return;

    var box = link.closest('.shg-box-content');
    if (!box) return;

    var headings = box.querySelectorAll('.shogun-heading-component h1, .shogun-heading-component h2, .shogun-heading-component h3, .shogun-heading-component h4, .shogun-heading-component h5, .shogun-heading-component h6');
    if (!headings.length) return;

    // Last heading is the article title, the one before it the publication
    var title = headings[headings.length - 1].textContent.trim().replace(/^["“”]+|["“”]+$/g, '');
    var publication = headings.length > 1 ? headings[headings.length - 2].textContent.trim() : '';
    if (!title) return;

    var label = 'Read More: ' + title + (publication ? ' - ' + publication : '');
    if (link.getAttribute('target') === '_blank') {
      label += EXTERNAL_WARNING;
    }
    link.setAttribute('aria-label', label);
  });

  /* ---------- Generic "Learn more" / "Read more" links ---------- */

  // A11Y-043: generic links without a name get "<link text>, <page from the URL>"
  var GENERIC_LINK_TEXT = /^(learn more|read more|more details|more info|more information|see more|view more|find out more|click here|here)$/i;

  function slugText(href) {
    var url;
    try { url = new URL(href, window.location.href); } catch (err) { return ''; }
    var parts = url.pathname.split('/').filter(Boolean).map(function (part) {
      try { return decodeURIComponent(part); } catch (err) { return part; }
    });
    var slug = '';
    for (var i = parts.length - 1; i >= 0; i--) {
      var part = parts[i].replace(/\.[a-z0-9]+$/i, '');
      if (/[a-z]{2,}/i.test(part) && !/^[a-z]?\d+$/i.test(part)) { slug = part; break; }
    }
    if (!slug) return url.hostname.replace(/^www\./, '');
    return slug.replace(/[-_+]+/g, ' ').replace(/\s+/g, ' ').trim()
      .replace(/\b\w/g, function (c) { return c.toUpperCase(); });
  }

  function labelGenericLinks() {
    each('a[href]', function (link) {
      if (link.hasAttribute('aria-label') || link.hasAttribute('aria-labelledby')) return;
      var text = link.textContent.replace(/\s+/g, ' ').trim().replace(/[.:!…]+$/, '');
      if (!GENERIC_LINK_TEXT.test(text)) return;
      var href = link.getAttribute('href');
      if (!href || href.charAt(0) === '#' || /^(javascript|mailto|tel):/i.test(href)) return;
      var slug = slugText(href);
      if (!slug) return;
      var external = link.hostname && link.hostname !== window.location.hostname;
      link.setAttribute('aria-label', text + ', ' + slug + (external && link.target === '_blank' ? EXTERNAL_WARNING : ''));
    });
  }

  onReady(function () {
    labelGenericLinks();
    setTimeout(labelGenericLinks, 1500); // links added by apps after load
  });

  /* ---------- Shogun "Discover" button labels ---------- */

  [
    ['https://carolinak.com/collections/new-arrivals-1', 'Discover more about Ready to Wear'],
    ['https://carolinak.com/collections/swimwear', 'Discover more Swimwear'],
    ['https://carolinak.com/collections/home', 'Discover more about Home Collection']
  ].forEach(function (item) {
    setAttr('a.shg-btn.shg-cse.shg-btn-text[href="' + item[0] + '"]', 'aria-label', item[1]);
  });

  // A11Y-061: muse buttons start with their visible text "Discover more"
  ['Anya Freeman', 'Kate Fleming', 'Beatriz Chachamovitz'].forEach(function (name) {
    each('a[href="https://carolinak.com/pages/' + name.toLowerCase().replace(' ', '-') + '"]', function (link) {
      var text = link.textContent.replace(/\s+/g, ' ').trim() || 'Discover more';
      link.setAttribute('aria-label', text + ' about ' + name + (link.target === '_blank' ? ' (opens in a new tab)' : ''));
    });
  });

  /* ---------- Mobile menu ---------- */

  on('click', '.slideout__trigger-mobile-menu.js-slideout-open', function () {
    setTimeout(function () {
      const drawer = document.getElementById('slideout-mobile-navigation');
      if (drawer) {
        removeAttr('.mobile-menu', 'aria-hidden');
        drawer.setAttribute('tabindex', '-1');
        drawer.focus();
      }
    }, 100);
  });

  /* ---------- Keyboard support for role="button" ---------- */

  each('[role="button"]', function (el) {
    el.setAttribute('tabindex', '0');
    el.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        triggerClick(this);
      }
    });
  });

  /* ---------- Hide #menu-item-1 from screen readers above 768px ---------- */

  function updateAriaHidden() {
    const menuItem = document.getElementById('menu-item-1');
    if (!menuItem) return;
    if (document.documentElement.clientWidth > 768) {
      menuItem.setAttribute('aria-hidden', 'true');
      menuItem.setAttribute('tabindex', '-1'); // A11Y-055: invisible (opacity 0) checkbox is also skipped by Tab
    } else {
      menuItem.removeAttribute('aria-hidden');
      menuItem.removeAttribute('tabindex');
    }
  }
  updateAriaHidden();
  window.addEventListener('resize', updateAriaHidden);

  /* ---------- Main menu dropdown toggles ---------- */

  // A11Y-005: name each toggle after its menu, e.g. "Shop submenu"
  onReady(function () {
    each('.menu-item-has-children > .dropdown-toggle', function (toggle) {
      var link = toggle.previousElementSibling;
      var menuName = link && link.matches('a') ? link.textContent.trim() : '';
      if (menuName) toggle.setAttribute('aria-label', menuName + ' submenu');
    });
  });

  /* ---------- Search and mobile menu drawers ---------- */

  // A11Y-007: drawer content is exposed and tabbable only while the drawer is open
  var NATIVE_FOCUSABLE = 'a[href], button, input, select, textarea, summary';
  var ROLE_FOCUSABLE = '[role="button"], [role="link"], [role="tab"], [role="checkbox"], [role="menuitem"], [role="switch"]';

  function syncDrawer(drawer) {
    var isOpen = drawer.classList.contains('slideout--active');
    if (drawer.getAttribute('aria-hidden') !== String(!isOpen)) {
      drawer.setAttribute('aria-hidden', String(!isOpen));
    }
    if (!isOpen) return; // theme.js sets tabindex="-1" on close
    drawer.querySelectorAll('[tabindex="-1"], ' + NATIVE_FOCUSABLE + ', ' + ROLE_FOCUSABLE).forEach(function (el) {
      var focusable = el.matches(NATIVE_FOCUSABLE) || el.matches(ROLE_FOCUSABLE);
      // Links in collapsed accordion panels stay out of the tab order
      if (focusable && el.closest('.c-accordion__panel:not(.is-active)')) {
        el.setAttribute('tabindex', '-1');
      } else if (el.getAttribute('tabindex') === '-1') {
        if (!el.matches(NATIVE_FOCUSABLE) && el.matches(ROLE_FOCUSABLE)) el.setAttribute('tabindex', '0');
        else el.removeAttribute('tabindex');
      }
    });
  }

  onReady(function () {
    setTimeout(function () {
      setAttr('#slideout-search-sidebar', 'aria-label', 'Search');
      setAttr('#slideout-mobile-collection-filters', 'aria-label', 'Filters'); // A11Y-053
      ['slideout-search-sidebar', 'slideout-mobile-navigation', 'slideout-mobile-collection-filters'].forEach(function (id) {
        var drawer = document.getElementById(id);
        if (!drawer) return;
        syncDrawer(drawer);
        // Re-sync when the drawer or an accordion panel inside it opens/closes
        new MutationObserver(function () { syncDrawer(drawer); })
          .observe(drawer, { attributes: true, attributeFilter: ['class'], subtree: true });
      });
    }, 1100); // after the 1000ms legacy setup above
  });

  // A11Y-053: mobile filter heading buttons report whether their panel is open
  on('click', 'button.a11y-filter-toggle', function () {
    var label = this.closest('h2');
    var panel = label && document.getElementById(label.id.replace('filter-accordion-label-', 'filter-accordion-content-'));
    if (panel) this.setAttribute('aria-expanded', String(!panel.classList.contains('collapsed')));
  });

  /* ---------- Carousels ---------- */

  // A11Y-008: no keyboard focus inside slides hidden with aria-hidden
  var CELL_FOCUSABLE = 'a[href], button, input, select, textarea, [tabindex]';

  function syncCell(cell) {
    var hidden = cell.getAttribute('aria-hidden') === 'true';
    cell.querySelectorAll(CELL_FOCUSABLE).forEach(function (el) {
      if (hidden) {
        if (!el.hasAttribute('data-a11y-tabindex')) {
          el.setAttribute('data-a11y-tabindex', el.getAttribute('tabindex') || '');
        }
        el.setAttribute('tabindex', '-1');
      } else if (el.hasAttribute('data-a11y-tabindex')) {
        var original = el.getAttribute('data-a11y-tabindex');
        if (original === '') el.removeAttribute('tabindex'); else el.setAttribute('tabindex', original);
        el.removeAttribute('data-a11y-tabindex');
      }
    });
  }

  function isCarouselCell(el) {
    return el.parentElement && el.parentElement.classList.contains('flickity-slider');
  }

  onReady(function () {
    each('.flickity-slider > *', syncCell);
    new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        if (isCarouselCell(m.target)) syncCell(m.target);
      });
    }).observe(document.body, { attributes: true, attributeFilter: ['aria-hidden'], subtree: true });
  });

  // A11Y-048: if Flickity wraps the product thumbnails, keep the list role on their real parent
  function fixThumbnailLists() {
    each('.js-thumb-carousel-nav[role="list"]', function (nav) {
      var item = nav.querySelector('.js-thumb-item[role="listitem"]');
      if (!item || item.parentElement === nav) return;
      item.parentElement.setAttribute('role', 'list');
      item.parentElement.setAttribute('aria-label', nav.getAttribute('aria-label') || 'Product images');
      nav.removeAttribute('role');
      nav.removeAttribute('aria-label');
    });
  }
  onReady(function () {
    fixThumbnailLists();
    setTimeout(fixThumbnailLists, 1500); // after the gallery carousel starts
  });

  /* ---------- Shogun forms ---------- */

  // A11Y-049: Shogun forms: labelled fields, required state, errors tied to fields and announced, success announced
  var shogunFormCount = 0;

  function isShown(el) {
    if (!el) return false;
    var style = window.getComputedStyle(el);
    return style.display !== 'none' && style.visibility !== 'hidden' && el.getClientRects().length > 0;
  }

  function liveRegion(role) {
    var region = document.createElement('div');
    region.className = 'Visually-hidden';
    region.setAttribute('role', role);
    document.body.appendChild(region);
    return region;
  }

  function speak(region, text) {
    region.textContent = '';
    setTimeout(function () { region.textContent = text; }, 100);
  }

  function setupShogunForm(form) {
    if (form.hasAttribute('data-a11y-form')) return;
    form.setAttribute('data-a11y-form', '');
    var n = ++shogunFormCount;
    var alertRegion = liveRegion('alert');
    var statusRegion = liveRegion('status');
    var fields = Array.prototype.slice.call(form.querySelectorAll('.shogun-form-field'));

    fields.forEach(function (field, i) {
      var wrap = field.parentElement;
      var label = wrap.querySelector('label');
      var error = wrap.querySelector('.shogun-form-error');
      if (!field.id) field.id = 'shogun-form-' + n + '-field-' + (i + 1);
      if (label) {
        label.htmlFor = field.id;
        field.removeAttribute('aria-label'); // use the visible label
      }
      if (error && !error.id) error.id = field.id + '-error';
      if (field.getAttribute('data-required') === 'true') field.setAttribute('aria-required', 'true');
    });

    function errorFor(field) { return field.parentElement.querySelector('.shogun-form-error'); }

    function syncErrors() {
      fields.forEach(function (field) {
        var error = errorFor(field);
        if (isShown(error)) {
          field.setAttribute('aria-invalid', 'true');
          field.setAttribute('aria-describedby', error.id);
        } else {
          field.removeAttribute('aria-invalid');
          field.removeAttribute('aria-describedby');
        }
      });
    }

    new MutationObserver(syncErrors).observe(form, { attributes: true, attributeFilter: ['style', 'class'], childList: true, characterData: true, subtree: true });

    var submit = form.querySelector('.shogun-form-submit');
    if (submit) {
      submit.addEventListener('click', function () {
        setTimeout(function () {
          syncErrors();
          var invalid = fields.filter(function (f) { return f.getAttribute('aria-invalid') === 'true'; });
          if (!invalid.length) return;
          var details = invalid.map(function (f) {
            var label = f.parentElement.querySelector('label');
            return (label ? label.textContent.trim() : f.name) + ': ' + errorFor(f).textContent.trim();
          });
          speak(alertRegion, 'Please fix ' + invalid.length + (invalid.length === 1 ? ' error. ' : ' errors. ') + details.join('. ') + '.');
          invalid[0].focus();
        }, 150);
      });
    }

    var success = form.parentElement && form.parentElement.querySelector('.shogun-success-alert');
    if (success) {
      var shown = isShown(success);
      new MutationObserver(function () {
        var now = isShown(success);
        if (now && !shown) {
          var text = success.textContent.replace(/\s+/g, ' ').trim();
          speak(statusRegion, text + (/sent|received/i.test(text) ? '' : ' Your message has been sent.'));
          success.setAttribute('tabindex', '-1');
          success.focus();
        }
        shown = now;
      }).observe(success, { attributes: true, attributeFilter: ['style', 'class'] });
    }
    syncErrors();
  }

  onReady(function () {
    each('.shogun-form', setupShogunForm);
    setTimeout(function () { each('.shogun-form', setupShogunForm); }, 1500); // forms rendered late by Shogun
  });

  /* ---------- Size guide tables ---------- */

  // A11Y-050: Shogun size tables get real <th> headers (columns + first column), keeping the td look
  var CELL_STYLE = ['padding-top', 'padding-right', 'padding-bottom', 'padding-left',
    'border-top', 'border-right', 'border-bottom', 'border-left', 'background-color',
    'font-family', 'font-size', 'font-weight', 'font-style', 'line-height', 'letter-spacing',
    'text-align', 'text-transform', 'color', 'vertical-align'];

  function cellToHeader(td, scope) {
    var computed = window.getComputedStyle(td);
    var th = document.createElement('th');
    Array.prototype.forEach.call(td.attributes, function (a) { th.setAttribute(a.name, a.value); });
    CELL_STYLE.forEach(function (prop) { th.style.setProperty(prop, computed.getPropertyValue(prop)); });
    th.setAttribute('scope', scope);
    th.removeAttribute('role'); // A11Y-060: interim header role not needed on a real th
    while (td.firstChild) th.appendChild(td.firstChild);
    td.parentNode.replaceChild(th, td);
  }

  // A11Y-060: a table with an empty header row is a layout list (e.g. stockist names)
  function isLayoutTable(table) {
    var head = table.querySelectorAll('thead td, thead th');
    return head.length > 0 && Array.prototype.every.call(head, function (cell) { return !cell.textContent.trim(); });
  }

  function fixSizeTables() {
    each('table.shogun-table:not([data-a11y-table])', function (table) {
      if (isLayoutTable(table)) {
        table.setAttribute('data-a11y-table', '');
        table.setAttribute('role', 'presentation');
        return;
      }
      if (!table.getClientRects().length) {
        // A11Y-060: hidden copies get header roles now (no visual change); real th once visible
        table.querySelectorAll('thead td:not([role])').forEach(function (td) { td.setAttribute('role', 'columnheader'); });
        table.querySelectorAll('tbody tr').forEach(function (tr) {
          var first = tr.querySelector('td');
          if (first && first === tr.firstElementChild && !first.hasAttribute('role')) first.setAttribute('role', 'rowheader');
        });
        return; // styles are only right once visible
      }
      table.setAttribute('data-a11y-table', '');
      table.querySelectorAll('thead td').forEach(function (td) { cellToHeader(td, 'col'); });
      table.querySelectorAll('tbody tr').forEach(function (tr) {
        var first = tr.querySelector('td');
        if (first && first === tr.firstElementChild) cellToHeader(first, 'row');
      });
    });
  }

  onReady(function () {
    fixSizeTables();
    setTimeout(fixSizeTables, 1500);
    window.addEventListener('resize', fixSizeTables);
    document.addEventListener('click', function () { setTimeout(fixSizeTables, 400); }); // tables shown in drawers/tabs
  });

  /* ---------- Shogun page headings ---------- */

  // A11Y-051: Shogun content headings: one h1, then no skipped levels (aria-level only, no visual change)
  function fixShogunHeadings() {
    var roots = document.querySelectorAll('.shogun-root');
    if (!roots.length) return;
    var outsideH1 = Array.prototype.some.call(document.querySelectorAll('h1'), function (h) {
      return !h.closest('.shogun-root') && h.getClientRects().length && h.getAttribute('role') !== 'none' && !h.hasAttribute('aria-level');
    });
    var usedH1 = outsideH1;
    var stack = outsideH1 ? [{ tag: 1, level: 1 }] : []; // open sections: original tag + exposed level
    var headings = [];
    roots.forEach(function (root) {
      root.querySelectorAll('h1, h2, h3, h4, h5, h6').forEach(function (h) {
        if (h.hasAttribute('role') && h.getAttribute('role') !== 'heading') { h.removeAttribute('aria-level'); return; } // e.g. accordion titles used as buttons
        headings.push(h);
      });
    });
    headings.forEach(function (h) {
      var tagLevel = parseInt(h.tagName.charAt(1), 10);
      while (stack.length && stack[stack.length - 1].tag >= tagLevel && !(stack.length === 1 && outsideH1)) stack.pop();
      var level = stack.length ? stack[stack.length - 1].level + 1 : (usedH1 ? 2 : 1);
      if (level === 1) usedH1 = true;
      if (level !== tagLevel) h.setAttribute('aria-level', String(level));
      else h.removeAttribute('aria-level');
      stack.push({ tag: tagLevel, level: level });
    });
  }
  onReady(function () {
    fixShogunHeadings();
    setTimeout(fixShogunHeadings, 1500);
  });

  /* ---------- Desktop navigation landmark ---------- */

  // A11Y-011: aria-expanded belongs on the menu button, not on the nav
  function cleanSiteNavigation() {
    removeAttr('#site-navigation', 'aria-expanded');
  }
  onReady(cleanSiteNavigation);
  on('click', '.menu-button', function () { setTimeout(cleanSiteNavigation); });

  // A11Y-023: "#" parent links go nowhere; keyboard and screen readers use their "<name> submenu" toggle
  onReady(function () {
    each('#menu-main li.menu-item-has-children > a[href="#"]', function (link) {
      var toggle = link.nextElementSibling;
      if (!toggle || !toggle.classList.contains('dropdown-toggle')) return;
      link.setAttribute('aria-hidden', 'true');
      link.setAttribute('tabindex', '-1');
      link.addEventListener('focus', function () {
        var keyboard = true;
        try { keyboard = link.matches(':focus-visible'); } catch (err) {}
        if (keyboard) toggle.focus(); // arrow-key focus moves on to the toggle
      });
    });
  });

  // A11Y-024: Escape keeps aria-expanded="false", returns focus to the toggle and hides hover-opened sub-menus
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var menu = document.getElementById('menu-main');
    if (!menu) return;
    var active = document.activeElement;
    var topItem = active && menu.contains(active) && active.closest('.sub-menu') ? active.closest('#menu-main > li') : null;
    setAttr('#menu-main .dropdown-toggle', 'aria-expanded', 'false');
    if (topItem) {
      var toggle = topItem.querySelector(':scope > .dropdown-toggle');
      if (toggle) toggle.focus();
    }
    if (menu.matches(':hover')) menu.classList.add('a11y-hover-off');
  });
  onReady(function () {
    var menu = document.getElementById('menu-main');
    if (menu) menu.addEventListener('mouseleave', function () { menu.classList.remove('a11y-hover-off'); });
  });

  /* ---------- Footer accordions ---------- */

  // A11Y-016: footer headings act as buttons on mobile, where the panels collapse
  var footerMobile = window.matchMedia ? window.matchMedia('(max-width: 740px)') : { matches: false };

  function footerContent(input) {
    var el = input.nextElementSibling;
    while (el && !el.classList.contains('footer-block-content')) el = el.nextElementSibling;
    return el;
  }

  function setupFooterAccordions() {
    each('.footer-menu label[for^="menu-item-"]', function (label) {
      var input = document.getElementById(label.getAttribute('for'));
      var heading = label.querySelector('h2');
      var content = input && footerContent(input);
      if (!heading || !content) return;

      var toggle = heading.querySelector('.a11y-footer-toggle');
      if (!toggle) {
        toggle = document.createElement('span');
        toggle.className = 'a11y-footer-toggle';
        while (heading.firstChild) toggle.appendChild(heading.firstChild);
        heading.appendChild(toggle);
        if (!content.id) content.id = 'footer-content-' + input.id;
        toggle.addEventListener('keydown', function (e) {
          if (toggle.getAttribute('role') === 'button' && (e.key === 'Enter' || e.key === ' ')) {
            e.preventDefault();
            input.click(); // toggles the panel and fires change
          }
        });
        input.addEventListener('change', function () {
          if (toggle.hasAttribute('aria-expanded')) toggle.setAttribute('aria-expanded', String(input.checked));
        });
      }

      if (footerMobile.matches) {
        toggle.setAttribute('role', 'button');
        toggle.setAttribute('tabindex', '0');
        toggle.setAttribute('aria-controls', content.id);
        toggle.setAttribute('aria-expanded', String(input.checked));
      } else {
        ['role', 'tabindex', 'aria-controls', 'aria-expanded'].forEach(function (name) {
          toggle.removeAttribute(name);
        });
      }
    });
  }

  onReady(setupFooterAccordions);
  if (footerMobile.addEventListener) {
    footerMobile.addEventListener('change', setupFooterAccordions);
  } else if (footerMobile.addListener) {
    footerMobile.addListener(setupFooterAccordions);
  }

  /* ---------- Cart link ---------- */

  // A11Y-027: cart link reads "My Bag, N items" and reports whether the Rebuy cart drawer is open
  var CART_LINKS = '.my-cart-link-container > a[href]';
  var lastCartLink = null;

  function cartTitle() {
    var label = document.querySelector('.my-cart-link-container .cart-links__item-label');
    return label && label.textContent.trim() ? label.textContent.trim() : 'My Bag';
  }

  function updateCartLinks() {
    var drawer = document.getElementById('rebuy-cart');
    each(CART_LINKS, function (link) {
      var countEl = link.querySelector('.js-cart-count');
      var count = countEl ? parseInt(countEl.textContent, 10) || 0 : 0;
      link.setAttribute('aria-label', cartTitle() + ', ' + count + (count === 1 ? ' item' : ' items'));
      if (drawer) {
        link.setAttribute('role', 'button'); // A11Y-036: opens the cart drawer, so it is announced as a button
        link.setAttribute('aria-haspopup', 'dialog');
        link.setAttribute('aria-controls', 'rebuy-cart');
        link.setAttribute('aria-expanded', String(drawer.classList.contains('is-visible')));
      }
    });
  }

  function watchCartDrawer(drawer) {
    var wasOpen = drawer.classList.contains('is-visible');
    new MutationObserver(function () {
      var isOpen = drawer.classList.contains('is-visible');
      if (isOpen === wasOpen) return;
      wasOpen = isOpen;
      updateCartLinks();
      // Return focus to the cart link if closing left it on the page body or in the drawer
      var active = document.activeElement;
      if (!isOpen && lastCartLink && (!active || active === document.body || drawer.contains(active))) {
        lastCartLink.focus();
      }
      if (!isOpen) lastCartLink = null;
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }

  on('click', CART_LINKS, function () { lastCartLink = this; });

  // A11Y-036: Space activates the cart button like Enter (native click so Rebuy opens the drawer)
  on('keydown', CART_LINKS, function (e) {
    if (e.key !== ' ' || this.getAttribute('role') !== 'button') return;
    e.preventDefault();
    this.click();
  });

  onReady(function () {
    updateCartLinks();
    each(CART_LINKS + ' .js-cart-count', function (countEl) {
      new MutationObserver(updateCartLinks).observe(countEl, { childList: true, characterData: true, subtree: true });
    });
    var drawer = document.getElementById('rebuy-cart');
    if (drawer) {
      watchCartDrawer(drawer);
      return;
    }
    // Rebuy adds its drawer after page load
    var finder = new MutationObserver(function () {
      var found = document.getElementById('rebuy-cart');
      if (!found) return;
      finder.disconnect();
      watchCartDrawer(found);
      updateCartLinks();
    });
    finder.observe(document.body, { childList: true, subtree: true });
  });

  /* ---------- WAVE fixes ---------- */

  /* ---------- Carousels: labels, status and hero dots ---------- */

  // A11Y-037: clearer arrow names, a spoken status after each move, keyboard hero dots, pause on focus
  var carouselStatus = null;

  function announce(text) {
    if (!carouselStatus) {
      carouselStatus = document.createElement('div');
      carouselStatus.className = 'Visually-hidden';
      carouselStatus.setAttribute('aria-live', 'polite');
      document.body.appendChild(carouselStatus);
    }
    carouselStatus.textContent = '';
    setTimeout(function () { carouselStatus.textContent = text; }, 100);
  }

  function flickityOf(el) {
    var carousel = el.closest('.flickity-enabled');
    return carousel && window.Flickity && window.Flickity.data ? window.Flickity.data(carousel) : null;
  }

  function carouselMessage(flkty) {
    var total = flkty.cells.length;
    if (flkty.element.classList.contains('js-slideshow')) {
      return 'Slide ' + (flkty.selectedIndex + 1) + ' of ' + flkty.slides.length;
    }
    var cells = flkty.selectedSlide ? flkty.selectedSlide.cells : [];
    if (!cells.length) return '';
    var first = flkty.cells.indexOf(cells[0]) + 1;
    var last = first + cells.length - 1;
    return first === last ? 'Showing product ' + first + ' of ' + total : 'Showing products ' + first + ' to ' + last + ' of ' + total;
  }

  function labelCarouselButtons(root) {
    root.querySelectorAll('.flickity-prev-next-button').forEach(function (btn) {
      btn.setAttribute('aria-label', btn.classList.contains('previous') ? 'Previous slide' : 'Next slide');
      btn.querySelectorAll('svg').forEach(function (svg) { svg.setAttribute('aria-hidden', 'true'); });
    });
  }

  // A11Y-045: hero dots follow the tabbed-carousel pattern (tablist/tab), allowed on ol/li
  function syncHeroDots(flkty) {
    var dots = flkty.element.querySelectorAll('.flickity-page-dots .dot');
    dots.forEach(function (dot, i) {
      var selected = i === flkty.selectedIndex;
      dot.setAttribute('aria-label', 'Slide ' + (i + 1) + ' of ' + dots.length);
      dot.setAttribute('aria-selected', String(selected));
      dot.setAttribute('tabindex', selected ? '0' : '-1');
      dot.removeAttribute('aria-current');
    });
  }

  function setupHero(el) {
    var flkty = window.Flickity && window.Flickity.data ? window.Flickity.data(el) : null;
    if (!flkty || el.hasAttribute('data-a11y-hero')) return;
    el.setAttribute('data-a11y-hero', '');
    var list = el.querySelector('.flickity-page-dots');
    if (list) {
      list.removeAttribute('aria-hidden');
      list.setAttribute('role', 'tablist');
      list.setAttribute('aria-label', 'Choose slide');
      var dots = list.querySelectorAll('.dot');
      dots.forEach(function (dot, i) {
        var cell = flkty.cells[i] && flkty.cells[i].element;
        dot.setAttribute('role', 'tab');
        if (cell && cell.id) {
          dot.setAttribute('aria-controls', cell.id);
          // A11Y-065: each slide is the tabpanel its dot controls
          cell.setAttribute('role', 'tabpanel');
          cell.setAttribute('aria-roledescription', 'slide');
          cell.setAttribute('aria-label', (i + 1) + ' of ' + dots.length);
        }
        dot.addEventListener('keydown', function (e) {
          var target = null;
          if (e.key === 'Enter' || e.key === ' ') target = i;
          else if (e.key === 'ArrowRight') target = (i + 1) % dots.length;
          else if (e.key === 'ArrowLeft') target = (i - 1 + dots.length) % dots.length;
          else if (e.key === 'Home') target = 0;
          else if (e.key === 'End') target = dots.length - 1;
          if (target === null) return;
          e.preventDefault();
          flkty.select(target);
          dots[target].focus();
          announce(carouselMessage(flkty));
        });
      });
      syncHeroDots(flkty);
      flkty.on('select', function () { syncHeroDots(flkty); });
    }
    if (flkty.options.autoPlay) setupHeroAutoplay(el, flkty);
  }

  // A11Y-039: pause/play button; autoplay pauses while focus is in the banner and resumes when it leaves
  function setupHeroAutoplay(el, flkty) {
    var region = el.closest('.slideshow-section') || el;
    var toggle = region.querySelector('[data-a11y-slideshow-toggle]');
    var userPaused = false;
    var focusInside = false;
    var playedInside = false; // Play pressed while focus is inside: play now

    function apply() {
      if (userPaused || (focusInside && !playedInside)) flkty.stopPlayer();
      else flkty.playPlayer();
      if (toggle) {
        toggle.setAttribute('aria-label', userPaused ? 'Play slideshow' : 'Pause slideshow');
        toggle.classList.toggle('is-paused', userPaused);
      }
    }

    region.addEventListener('focusin', function () {
      if (!focusInside) { focusInside = true; playedInside = false; }
      apply();
    });
    region.addEventListener('focusout', function (e) {
      if (region.contains(e.relatedTarget)) return;
      focusInside = false;
      playedInside = false;
      apply();
    });
    if (toggle) {
      toggle.addEventListener('click', function () {
        userPaused = !userPaused;
        if (!userPaused) playedInside = true;
        apply();
      });
    }
    apply();
  }

  on('click', '.flickity-prev-next-button', function () {
    var flkty = flickityOf(this);
    if (flkty) announce(carouselMessage(flkty));
  });

  onReady(function () {
    labelCarouselButtons(document);
    setTimeout(function () {
      labelCarouselButtons(document);
      each('.js-slideshow.flickity-enabled', setupHero);
    }, 1100); // after the 1000ms legacy setup, which hides the dots
    new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (node) {
          if (node.nodeType === 1 && (node.matches('.flickity-prev-next-button') || node.querySelector('.flickity-prev-next-button'))) {
            labelCarouselButtons(node.parentElement || node);
          }
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  });

  // A11Y-032: hidden tracking pixels added by apps get alt="" so they are ignored
  function fixPixel(img) {
    if (img.hasAttribute('alt')) return;
    var tiny = img.getAttribute('width') === '0' || img.getAttribute('height') === '0' ||
      img.getAttribute('width') === '1' || img.getAttribute('height') === '1';
    if (tiny) {
      img.setAttribute('alt', '');
    }
  }
  // A11Y-030: the Hulk app's icon-only wishlist link gets a name
  function fixWishlistLink(link) {
    if (link.getAttribute('aria-label') || link.textContent.trim()) return;
    link.setAttribute('aria-label', 'Wishlist');
    link.querySelectorAll('i, svg').forEach(function (icon) { icon.setAttribute('aria-hidden', 'true'); });
  }

  onReady(function () {
    each('img:not([alt])', fixPixel);
    each('a.hulk-wishlist-drawer', fixWishlistLink);
    new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.tagName === 'IMG') fixPixel(node);
          else if (node.querySelectorAll) node.querySelectorAll('img:not([alt])').forEach(fixPixel);
          if (node.matches('a.hulk-wishlist-drawer')) fixWishlistLink(node);
          else if (node.querySelectorAll) node.querySelectorAll('a.hulk-wishlist-drawer').forEach(fixWishlistLink);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  });

  /* ---------- PowerMapper fixes ---------- */

  // A11Y-054: the closed Rebuy cart drawer is out of the Tab order (still focusable by script, so Rebuy can focus it on open)
  var DRAWER_FOCUSABLE = 'a[href], button, input, select, textarea, [tabindex]';

  function syncCartTabbing(drawer) {
    var open = drawer.classList.contains('is-visible');
    drawer.querySelectorAll(DRAWER_FOCUSABLE).forEach(function (el) {
      if (!open && !el.hasAttribute('data-a11y-cart-tabindex')) {
        el.setAttribute('data-a11y-cart-tabindex', el.getAttribute('tabindex') || '');
        el.setAttribute('tabindex', '-1');
      } else if (open && el.hasAttribute('data-a11y-cart-tabindex')) {
        var original = el.getAttribute('data-a11y-cart-tabindex');
        if (original === '') el.removeAttribute('tabindex'); else el.setAttribute('tabindex', original);
        el.removeAttribute('data-a11y-cart-tabindex');
      }
    });
  }

  function watchCartTabbing(drawer) {
    syncCartTabbing(drawer);
    new MutationObserver(function () { syncCartTabbing(drawer); })
      .observe(drawer, { attributes: true, attributeFilter: ['class'], childList: true, subtree: true });
  }

  onReady(function () {
    var drawer = document.getElementById('rebuy-cart');
    if (drawer) { watchCartTabbing(drawer); return; }
    var finder = new MutationObserver(function () {
      var found = document.getElementById('rebuy-cart');
      if (!found) return;
      finder.disconnect();
      watchCartTabbing(found);
    });
    finder.observe(document.body, { childList: true, subtree: true });
  });

  // A11Y-057: Shogun press image links take the name of the "Read More" link to the same article
  function labelImageLinks() {
    each('a.shogun-image-link[href]', function (link) {
      if (link.getAttribute('aria-label') || link.textContent.trim() || link.querySelector('img[alt]:not([alt=""])')) return;
      var href = link.getAttribute('href');
      var name = '';
      each('a[aria-label^="Read More: "]', function (other) {
        if (!name && other.getAttribute('href') === href) name = other.getAttribute('aria-label').replace(/^Read More: /, '');
      });
      if (!name) return;
      link.setAttribute('aria-label', name);
      link.querySelectorAll('img:not([alt])').forEach(function (img) { img.setAttribute('alt', ''); });
    });
  }

  // A11Y-058: embedded video players get a title, e.g. "Video: Our Story and Mission"
  function titleVideoFrames() {
    each('iframe:not([title]):not([aria-label]):not([aria-labelledby])', function (frame) {
      if (frame.getAttribute('aria-hidden') === 'true') return;
      if (!/cloudflarestream\.com|youtube(-nocookie)?\.com|vimeo\.com|wistia\.(com|net)/i.test(frame.src)) return;
      var h1 = document.querySelector('main h1, h1');
      var page = h1 ? h1.textContent.replace(/\s+/g, ' ').trim() : '';
      frame.setAttribute('title', page ? 'Video: ' + page : 'Video');
    });
  }

  // A11Y-059: empty headings in page content (no text, no image text) are hidden from screen readers
  var CONTENT_HEADINGS = ['.rte', '.shogun-root'].map(function (root) {
    return ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'].map(function (tag) { return root + ' ' + tag; }).join(', ');
  }).join(', ');

  function hideEmptyHeadings() {
    each(CONTENT_HEADINGS, function (h) {
      if (h.textContent.replace(/ /g, ' ').trim() || h.getAttribute('aria-label') || h.getAttribute('aria-labelledby')) return;
      if (h.querySelector('img[alt]:not([alt=""]), svg[aria-label], [role="img"][aria-label]')) return;
      h.setAttribute('aria-hidden', 'true');
    });
  }

  // A11Y-061: content links whose old "this link will open in a new tab" label no longer matches their visible text
  function fixMismatchedLabels() {
    each('a[aria-label$="this link will open in a new tab" i]', function (link) {
      var text = link.textContent.replace(/\s+/g, ' ').trim();
      var label = link.getAttribute('aria-label').replace(/\s+/g, ' ').toLowerCase();
      if (!text || label.indexOf(text.toLowerCase()) !== -1) return;
      var external = link.hostname && link.hostname !== window.location.hostname;
      var warning = link.target === '_blank' ? (external ? EXTERNAL_WARNING : ' (opens in a new tab)') : '';
      link.setAttribute('aria-label', text + warning);
    });
  }

  function powerMapperFixes() {
    labelImageLinks();
    titleVideoFrames();
    hideEmptyHeadings();
    fixMismatchedLabels();
  }

  onReady(function () {
    powerMapperFixes();
    setTimeout(powerMapperFixes, 1500); // content added by apps after load
  });

})();
